import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-352a638b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "landing-page"
};
const _hoisted_2 = {
  class: "particles"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "logo"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "title"
}, "多多助手", -1));
const _hoisted_6 = {
  class: "enter-button-container"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "进入系统", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "button-shadow"
}, null, -1));
const _hoisted_9 = {
  class: "floating-elements"
};
const _hoisted_10 = {
  class: "floating-icon icon-1"
};
const _hoisted_11 = {
  class: "floating-icon icon-2"
};
const _hoisted_12 = {
  class: "floating-icon icon-3"
};
const _hoisted_13 = {
  class: "floating-icon icon-4"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "version"
}, "V 1.0.0", -1));
import { onMounted } from "vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/Object.assign({
  name: "LandingPage"
}, {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    onMounted(() => {
      // 为粒子添加随机动画
      const particles = document.querySelectorAll(".particle");
      particles.forEach(particle => {
        // 随机位置
        const x = Math.random() * 100;
        const y = Math.random() * 100;

        // 随机大小
        const size = Math.random() * 4 + 2;

        // 随机动画延迟和持续时间
        const delay = Math.random() * 4;
        const duration = Math.random() * 8 + 8;
        particle.style.left = `${x}%`;
        particle.style.top = `${y}%`;
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        particle.style.animationDelay = `${delay}s`;
        particle.style.animationDuration = `${duration}s`;
      });
    });
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(50, n => {
        return _createElementVNode("div", {
          key: n,
          class: "particle"
        });
      }), 64))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_icon, {
        name: "logistics",
        size: "64",
        color: "#FF6E00"
      })]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_button, {
        class: "enter-button",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/home')),
        type: "danger",
        size: "large",
        round: "",
        color: "#FF6E00"
      }, {
        default: _withCtx(() => [_hoisted_7, _createVNode(_component_van_icon, {
          name: "arrow"
        })]),
        _: 1
      }), _hoisted_8])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_van_icon, {
        name: "orders-o",
        size: "24",
        color: "#FF6E00"
      })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_icon, {
        name: "chart-trending-o",
        size: "28",
        color: "#FF6E00"
      })]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_icon, {
        name: "balance-o",
        size: "26",
        color: "#FF6E00"
      })]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_van_icon, {
        name: "cashier-o",
        size: "22",
        color: "#FF6E00"
      })])]), _hoisted_14]);
    };
  }
});